import { type FC } from "react";
import { Typography } from "@/components/essentials/typography";
import { SuccessCard, typographyVariant } from "@/components/fragments/card";
import { pagesPath } from "@/pathpida/generated/$path";

export const SuccessScreen: FC = () => {
  return (
    <SuccessCard
      text="パスワードの変更が完了しました"
      buttonText="サインイン画面へ"
      buttonHref={pagesPath.signin.$url()}
    >
      <Typography mt="1rem" variant={typographyVariant} textAlign="center">
        変更後のパスワードで
        <br />
        再度サインインしてください
      </Typography>
    </SuccessCard>
  );
};
